import React from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {useOrganizationRoutes} from 'organization/OrganizationRoutes'
import {routes} from 'routes/routes'
import {useOrganizationAuth} from 'organization/Auth/Providers/OrganizationAuthProvider'
import {useI18n} from 'i18n/I18nContext'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import DescriptionIcon from '@mui/icons-material/Description'
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'
import Settings from '@mui/icons-material/Settings'
import Event from '@mui/icons-material/Event'
import LiveHelpIcon from '@mui/icons-material/LiveHelp'
import TranslateIcon from '@mui/icons-material/Translate'

const ADMIN_EMAIL = 'abeytulov@gmail.com'

const OrganizationMenu = () => {
  const routesOrg = useOrganizationRoutes()
  const {user} = useOrganizationAuth()
  const {t} = useI18n()
  const showTranslations = user?.email?.toLowerCase() === ADMIN_EMAIL

  return (
    <>
      <li>
        <LocalLink to={routesOrg.events}>
          {' '}
          <i>
            <Event />
          </i>
          <span className="nav-text">{t('org.menu.events')}</span>
        </LocalLink>
      </li>
      <li>
        <LocalLink to={routesOrg.invoices}>
          <i>
            <DescriptionIcon />
          </i>
          <span className="nav-text">{t('org.menu.invoices')}</span>
        </LocalLink>
      </li>
      <li>
        <LocalLink to={routesOrg.earnings}>
          <i>
            <PointOfSaleIcon />
          </i>
          <span className="nav-text">{t('org.menu.earnings')}</span>
        </LocalLink>
      </li>
      <li>
        <LocalLink to={routesOrg.affiliateProgram}>
          {' '}
          <i>
            <QueryStatsIcon />
          </i>
          <span className="nav-text">{t('org.menu.affiliate')}</span>
        </LocalLink>
      </li>
      <li>
        <LocalLink to={routesOrg.settings.root}>
          {' '}
          <i>
            <Settings />
          </i>
          <span className="nav-text">{t('org.menu.settings')}</span>
        </LocalLink>
      </li>

      <li>
        <LocalLink to={routesOrg.help}>
          <i>
            <LiveHelpIcon />
          </i>
          <span className="nav-text">{t('org.menu.help')}</span>
        </LocalLink>
      </li>

      {showTranslations && (
        <li>
          <LocalLink to={routes.organization.i18nStudio}>
            <i>
              <TranslateIcon />
            </i>
            <span className="nav-text">{t('lang.editorMenu')}</span>
          </LocalLink>
        </li>
      )}
    </>
  )
}

export default OrganizationMenu
